import React from 'react';
import ImageWithLoader from '../../utils/ImageWithLoader';

const ImageBlock = ({...props}) => (
  <ImageWithLoader retryIfNotFound borderRadius={0} {...props} />
);

export default ImageBlock;
